/**
 * Following the duck pattern, actions, constants and reducers are in the same file called module.js
 *
 * See: https://github.com/erikras/ducks-modular-redux
 *
 */

import { call, put, select, takeEvery } from 'redux-saga/effects'
import { replace } from 'react-router-redux'
import { toastr } from 'react-redux-toastr'
import request from 'shared/services/networking'

export const AUTHENTICATE_USER_REQUEST = 'Authentication/AUTHENTICATE_USER_REQUEST'
export const AUTHENTICATE_USER_SUCCESS = 'Authentication/AUTHENTICATE_USER_SUCCESS'
export const AUTHENTICATE_USER_ERROR = 'Authentication/AUTHENTICATE_USER_ERROR'

export const LOGOUT_USER_REQUEST = 'Authentication/LOGOUT_USER_REQUEST'
export const LOGOUT_USER_SUCCESS = 'Authentication/LOGOUT_USER_SUCCESS'
export const LOGOUT_USER_ERROR = 'Authentication/LOGOUT_USER_ERROR'

export function authenticateUserRequest (username, password, redirectPath) {
  return {
    type: AUTHENTICATE_USER_REQUEST,
    payload: { username, password, redirectPath }
  }
}

export function authenticateUserSuccess (token) {
  return {
    type: AUTHENTICATE_USER_SUCCESS,
    payload: token
  }
}

export function authenticateUserError (error) {
  return {
    type: AUTHENTICATE_USER_ERROR,
    payload: error
  }
}

export function logoutUserRequest () {
  return {
    type: LOGOUT_USER_REQUEST
  }
}

export function logoutUserSuccess (token) {
  return {
    type: LOGOUT_USER_SUCCESS
  }
}

export function logoutUserError (error) {
  return {
    type: LOGOUT_USER_ERROR,
    payload: error
  }
}

export const getTokenSelector = state => state.user.token

export function * authenticateUser (action) {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_API_URL}/authentication/`,
    data: {
      username: action.payload.username,
      password: action.payload.password
    }
  }
  try {
    const user = yield call(request, config)
    const redirectPath = action.payload.redirectPath ? action.payload.redirectPath : '/admin/'
    yield put(authenticateUserSuccess(user))
    yield put(replace(redirectPath))
  } catch (error) {
    yield put(authenticateUserError(error))
    yield call(toastr.error, 'Erreur', 'Login ou mot de passe incorrect')
  }
}

export function * logoutUser (action) {
  const token = yield select(getTokenSelector)
  const config = {
    headers: {
      'Authorization': 'Token ' + token
    },
    method: 'get',
    url: `${process.env.REACT_APP_API_URL}/common/logout/`
  }
  try {
    yield call(request, config)
    yield put(logoutUserSuccess())
    yield call(toastr.success, 'Succès', 'Vous avez bien été déconnecté')
    yield put(replace('/admin/login/'))
  } catch (error) {
    yield put(logoutUserError(error))
  }
}

export function * authenticateUserSaga () {
  yield takeEvery(AUTHENTICATE_USER_REQUEST, authenticateUser)
}

export function * logoutUserSaga () {
  yield takeEvery(LOGOUT_USER_REQUEST, logoutUser)
}

const initialState = {
  token: null,
  error: null,
  isUserAuthenticated: false
}

/**
 * Following the duck pattern, the module.js file should export a reducer as a default function
 */
export function reducer (state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATE_USER_REQUEST:
      return {
        ...state,
        error: null
      }
    case AUTHENTICATE_USER_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        isUserAuthenticated: true,
        error: null
      }
    case AUTHENTICATE_USER_ERROR:
      return {
        ...state,
        error: action.payload
      }
    case LOGOUT_USER_REQUEST:
      return {
        ...state,
        error: null
      }
    case LOGOUT_USER_SUCCESS:
      return {
        ...initialState
      }
    case LOGOUT_USER_ERROR:
      return {
        ...initialState,
        error: action.payload
      }
    default:
      return state
  }
}

export default reducer
